<template>
  <div class="pieChart" id="pieChart"></div>
</template>
<script>
/**
 * @file:  View 组件 echart
 * @author: v_chengmengya
 * @date: 2019-05-20
 * @description: UI组件 柱状图 无x轴y轴
 */
import echarts from 'echarts'
export default {
  props: {
    allNumber: {
      default: '0',
      type: [String, Number]
    },
    pieData: {
      default: () => {
        return []
      },
      type: Array
    },
    height: {
      default: '',
      type: [String, Number]
    }
  },
  watch: {
    height: function() {},
    pieData: function() {
      if(this.pieData.length>0)this.initChart();
    }
  },
  methods: {
    initChart() {
      let that = this
   
      document.getElementById('pieChart').style.height = that.height + 'px'
      let city = echarts.init(document.getElementById('pieChart'))
      if(city){
        city.clear()
      }
     
      var option = {
        title: {
          text: `途经车辆注册省份    合计:${this.allNumber}    单位：车次`,
          left: 30
        },
        dataset: {
          source: this.pieData
        },
        grid: { containLabel: true, top: 50, left: 30, right: 30, bottom: 10 },
        xAxis: { name: 'amount', show: false },
        yAxis: {
          type: 'category',
          //type: 'value',
          interval: 500,
          axisLine: {
            show: false // 不显示坐标轴线
          },
          axisTick: {
            show: false // 不显示刻度
          }
        },
        animation: true,
        visualMap: {
          orient: 'horizontal',
          left: 'center',
          min: 10,
          max: 100,
          show: false,
          inRange: {
            color: ['#00A589', '#00A589']
          }
        },
        series: [
          {
            type: 'bar',
            encode: {
              // Map the "amount" column to X axis.
              x: 'amount',
              // Map the "product" column to Y axis
              y: 'product'
            },
            barWidth: 18,
            label: {
              normal: {
                show: true,
                position: 'right',
                color: '#000'
              }
            }
          }
        ]
      }
      city.resize()
      city.setOption(option)
    }
  },
  mounted() {
    //this.initChart()
  }
}
</script>

